import React from 'react';

export function useMediaQuery(query: string) {
  const [match, setMatch] = React.useState(false);
  const [determined, setDetermined] = React.useState(false);

  React.useEffect(() => {
    const mediaQuery = window.matchMedia(query);
    function mediaQueryListener(e: MediaQueryListEvent) {
      setMatch(e.matches);
    }
    setMatch(mediaQuery.matches);
    setDetermined(true);
    mediaQuery.addListener(mediaQueryListener);
    return () => mediaQuery.removeListener(mediaQueryListener);
  }, [query]);

  return [match, determined];
}
